// extracted by mini-css-extract-plugin
export default {"image":"aboutus_image__5g56m","mainsection":"aboutus_mainsection__Qp8z0","subsection":"aboutus_subsection__wk01f","mail":"aboutus_mail__eOwsk","main":"aboutus_main__-ICzn"};